// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';

export const getTaskType = createAsyncThunk('taskTypeSliceData/getTaskType', async () => {
    try {
        let response = await axios.get('/TaskType', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const getTaskTypeStatus = createAsyncThunk('taskTypeSliceData/getTaskTypeStatus', async () => {
    try {
        let response = await axios.get('/TaskType?status=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const deleteTaskType = createAsyncThunk('taskTypeSliceData/deleteTaskType', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/TaskType/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Task Type deleted successfully.');
        await dispatch(getTaskType());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const createTaskType = createAsyncThunk('taskTypeSliceData/createTaskType', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/TaskType', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Task Type added successfully.');
        await dispatch(getTaskType());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateTaskType = createAsyncThunk('taskTypeSliceData/updateTaskType', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/TaskType/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Task Type updated succesfully.');
        await dispatch(getTaskType());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateTaskTypeStatus = createAsyncThunk('taskTypeSliceData/updateTaskTypeStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/TaskType/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status Updated Succesfully');
        await dispatch(getTaskType());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const taskTypeSlice = createSlice({
    name: 'taskTypeSliceData',
    initialState: {
        taskType: [],
        taskTypeStatus: []
    },
    extraReducers: (builder) => {
        builder.addCase(getTaskType.fulfilled, (state, action) => {
            state.taskType = action?.payload;
            return;
        });
        builder.addCase(getTaskTypeStatus.fulfilled, (state, action) => {
            state.taskTypeStatus = action?.payload;
            return;
        });
    }
});

export default taskTypeSlice.reducer;
